import React from 'react';
import ResourceWorkspace from '../../components/admin/ResourceWorkspace';

const tabs = [
  {
    "title": "Marketplace orders",
    "resource": "p2p/marketplaceorder",
    "columns": [
      "id",
      "order_id",
      "buyer",
      "seller",
      "btc_amount",
      "usd_value",
      "status",
      "admin_reviewed",
      "created"
    ]
  },
  {
    "title": "Assets",
    "resource": "p2p/marketplaceasset"
  },
  {
    "title": "P2P orders",
    "resource": "p2p/p2porder"
  },
  {
    "title": "Escrow",
    "resource": "p2p/p2pescrow"
  },
  {
    "title": "Disputes",
    "resource": "p2p/p2pdispute"
  },
  {
    "title": "Advertisements",
    "resource": "p2p/p2pad"
  },
  {
    "title": "Merchant profiles",
    "resource": "p2p/p2puserprofile"
  },
  {
    "title": "Payment methods",
    "resource": "p2p/p2ppaymentmethod"
  },
  {
    "title": "P2P settings",
    "resource": "p2p/p2psettings"
  }
];

export default function MarketplaceOrdersPage() {
  return <ResourceWorkspace title="Marketplace & P2P oversight"  tabs={tabs} />;
}
